import apiService from 'src/services/ApiCallService';
import ErrorUtils from 'src/utils/ErrorUtils';
import { FramesSearchType, GetFramesAccountsResponse } from 'src/models/Frames';
import { formatFramesRecord } from 'src/utils/FramesUtils';

export default class FramesService {
  /**
   * Fetches accounts from FRAMES
   * @returns An object containing the accounts or error message if operation fails.
   */
  async getFramesAccounts(accountNum: string, searchType: FramesSearchType) {
    let framesAccounts: string[] = [];
    let error: string | undefined = undefined;
    try {
      const response = await apiService.getFramesAccounts(accountNum, searchType);
      const data: GetFramesAccountsResponse = await response.json();
      framesAccounts = data.framesAccounts?.map(formatFramesRecord) || [];
    } catch (ex) {
      error = ErrorUtils.getMessage(ex);
    }

    return {
      framesAccounts,
      error,
    };
  }
}
